import React from 'react';
import { countries } from 'country-flags-svg';
import AvatarImage from 'assets/images/avatar-image.png';
import { beautifyDate } from 'utils/dateUtils';
import classes from './ResumeTemplate4.module.scss';

const ResumeTemplate4 = ({ data }) => {
    return (
        <div className={classes["resumeContainer"]}>
            <div className={classes.line}></div>
            <div className={classes['about-me']}>
                <div className={classes.bullet}></div>
                <div className={classes.profilePicture}>
                    <img src={data.user.image ? data.user.image : AvatarImage.src} alt="Profile" />
                </div>
                <div>
                    <h1>{data.user.first_name} {data.user.last_name}</h1>
                    <div className='d-flex justify-content-between gap-4 flex-wrap'>
                        {data.contact_information.phone_number && (
                            <p>Contact Number:<br /><strong><span className={classes['color-blue']}> {data.contact_information.phone_number}</span></strong></p>
                        )}
                        {data.contact_information.email && (
                            <p>Email:<br /><strong><span className={classes['color-blue']}> {data.contact_information.email}</span></strong></p>
                        )}
                        {data?.about_me.residential_country_iso && (
                            <p>Residential Location:<br /><strong><span className={classes['color-blue']}>{countries.find((crty) => crty.iso2 === data?.about_me.residential_country_iso)?.name || ''}</span></strong></p>
                        )}
                    </div>
                    <p>{data.about_me.about_me}</p>
                    <div>
                        {data.about_me.languages?.length > 0 && (
                            <div className={classes.languages}>
                                <h3>Language:</h3>
                                {data.about_me.languages.map((lang) => (
                                    <p><strong>{lang?.language?.name}</strong> ({lang?.proficiency?.proficiency})</p>
                                ))}
                            </div>
                        )}
                        {data.about_me.birth_date_beautify && (
                            <div className='d-flex gap-3'>
                                <h3>Date of Birth:</h3>
                                <p><strong>{data.about_me.birth_date_beautify}</strong></p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {data.work_experience?.work_experiences?.length > 0 && (
                <div className={classes.workExperience}>
                    <div className={classes.bullet}></div>
                    <h2>Work<br /> Experience</h2>
                    <div>
                        {data.work_experience.work_experiences.map((exp) => (
                            <div className={`${classes.job} avoid-break`}>
                                <div>
                                    <p><strong>{exp.job_title}</strong></p>
                                    <p>{exp.company_name}</p>
                                    <p style={{ color: '#666664' }}>{beautifyDate(exp.start_date)} - {exp.start_date ? beautifyDate(exp.start_date) : 'Now'}</p>
                                    <p>{exp.employment_status.status}</p>
                                </div>
                                <p>{exp.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {data.education?.education?.length > 0 && (
                <div className='d-flex position-relative avoid-break'>
                    <div className={classes.bullet}></div>
                    <h2>Education</h2>
                    <div className={classes.educations}>
                        {data.education.education.map((edu) => (
                            <div className={classes.education}>
                                <p><strong>{edu.university}</strong></p>
                                <p>{edu.education_degree.degree}, {edu.field_or_major}</p>
                                <br />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {(data.skills.software_skills || data.skills.technical_skills) && (
                <div className='d-flex position-relative avoid-break'>
                    <div className={classes.bullet}></div>
                    <h2>Skills</h2>
                    <div className={classes.skills}>
                        {data.skills.software_skills && (
                            <div>
                                <p><strong>Software Skills</strong></p>
                                <p>{data.skills.software_skills}</p>
                            </div>
                        )}
                        {data.skills.technical_skills && (
                            <div>
                                <p><strong>Technical Skills</strong></p>
                                <p>{data.skills.technical_skills}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}


        </div>
    );
};

export default ResumeTemplate4;